import React, { useState, useEffect } from "react";
import axios from "axios";
import getAPI from "../../service/getAPI";
import { Table, Form, Button } from "react-bootstrap";

function UnicommerceDataSearch() {
  const { master } = getAPI();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [authToken, setAuthToken] = useState(null);

  // **State for Date Inputs**
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateType, setDateType] = useState("created");

  useEffect(() => {
    loginUser();
  }, []);

  // **Step 1: Login & Get Token**
  const loginUser = async () => {
    setLoading(true);
    try {
      const loginResponse = await axios.get(master.unicommerce_login);

      if (loginResponse.data?.access_token) {
        const token = `${loginResponse.data.token_type} ${loginResponse.data.access_token}`;
        setAuthToken(token);
        localStorage.setItem("authToken", token);
      } else {
        setError("Login failed, no token received.");
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // **Step 2: Fetch Orders**
  const fetchOrders = async () => {
    if (!authToken) {
      setError("No authentication token found. Please log in again.");
      return;
    }
    if (!fromDate || !toDate) {
      setError("Please select a valid date range.");
      return;
    }

    // Convert dates to DateTime format
    const fromDateTime = new Date(fromDate + "T00:00:00.000Z").toISOString();
    const toDateTime = new Date(toDate + "T23:59:59.000Z").toISOString();
    const formattedDateType = dateType.toUpperCase(); // ✅ Convert to uppercase

    console.log("Formatted Request:", {
      fromDateTime,
      toDateTime,
      formattedDateType,
    });

    setLoading(true);
    try {
      const res = await axios.post(
        master.unicommerce_order_data,
        {
          fromDate: fromDateTime,
          toDate: toDateTime,
          dateType: formattedDateType, // ✅ Ensures dateType is uppercase
        },
        { headers: { Authorization: authToken } }
      );

      setOrders(res.data.orders);
    } catch (err) {
      console.error("Order Fetch Error:", err);
      setError("Failed to fetch order data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>Unicommerce Orders</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Masters</a>
            </li>
            <li className="breadcrumb-item active">Unicommerce Orders</li>
          </ol>
        </nav>
      </div>

      {loading && <p>Loading...</p>}
      {error && <p className="text-danger">{error}</p>}

      {/* Date Selection Form */}
      <div className="row mb-3">
        <div className="col-md-3">
          <label>From Date</label>
          <Form.Control
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label>To Date</label>
          <Form.Control
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label>Date Type</label>
          <Form.Select
            value={dateType}
            onChange={(e) => setDateType(e.target.value.toUpperCase())}
          >
            <option value="CREATED">Created</option>
            <option value="UPDATED">Updated</option>
            <option value="COMPLETED">Completed</option>
          </Form.Select>
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <Button onClick={fetchOrders} className="btn btn-primary w-100">
            Get Orders
          </Button>
        </div>
      </div>

      {/* Orders Table */}
      <div className="row mt-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body pt-3">
              <Table striped bordered hover responsive>
                <thead>
                  <tr className="table-secondary">
                    <th>No.</th>
                    <th>Order Code</th>
                    <th>Tracking Number</th>
                    <th>Shipping Courier</th>
                    <th>Order Date</th>
                    <th>Name</th>
                    <th>Mobile No</th>
                    <th>Product</th>
                    <th>Address</th>
                    <th>State</th>
                    <th>Pincode</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.length > 0 ? (
                    orders.map((order, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{order.order_code}</td>
                        <td>{order.tracking_number}</td>
                        <td>{order.shipping_courier}</td>
                        <td>{order.order_date}</td>
                        <td>{order.customer_name}</td>
                        <td>{order.phone_number}</td>
                        <td>{order.product}</td>
                        <td>{order.address}</td>
                        <td>{order.state}</td>
                        <td>{order.pincode}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default UnicommerceDataSearch;
